import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, VuexModule, Action, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import moment from 'moment';
import store from '@/store';
import { isObject } from 'lodash';
import { hideModal } from '@/core/helpers/dom';
import { MutationsGeneral } from '@/store/enums/pscm/migo/generalEnum';
let transactionGiModule = class transactionGiModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isOnImport = false;
        this.isGiSearched = false;
        this.tabConditionGi = 'header';
        this.tempId = null;
        this.headerId = 0;
        this.viewHeader = {};
        this.typeOfDocument = '';
        this.importFileGi = {
            files: null,
            store: [],
            isError: false,
            isImported: false,
            isAllowImport: true,
            isOnAsync: false
        };
        this.errorListGiCreate = [
            {
                line: 0,
                materialDesc: false,
                qty: false,
                slocCode: false,
                stockTypeCode: false,
                vendorName: false,
                costCenter: false,
                orderNumber: false,
                movementType: false,
                reasonMovementName: false,
                textItem: false,
                reasonMovementCode: false
            }
        ];
        this.errorListGiOther = [
            {
                materialDesc: false,
                qty: false,
                slocCode: false,
                stockTypeCode: false,
                vendorName: false,
                costCenter: false,
                orderNumber: false,
                movementType: false
            }
        ];
        this.giLookup = {
            typeorder: [
                {
                    lookupVal: 'Order',
                    lookupText: 'Order',
                    lookupData: null,
                    lookupValText: 'Order | Order'
                },
                {
                    lookupVal: 'Reservation',
                    lookupText: 'Reservation',
                    lookupData: null,
                    lookupValText: 'Reservation | Reservation'
                },
                {
                    lookupVal: 'Other',
                    lookupText: 'Other',
                    lookupData: null,
                    lookupValText: 'Other | Other'
                },
                {
                    lookupVal: 'PurchaseOrder',
                    lookupText: 'Purchase Order',
                    lookupData: null,
                    lookupValText: 'PurchaseOrder | Purchase Order'
                }
            ],
            stockType: [],
            delCompleteInd: [],
            sloc: [],
            slocHead: [],
            mvtype: [],
            specialstock: [],
            valtype: [],
            vendor: [],
            reasonMv: [],
            plant: [],
            material: [],
            costCenter: []
        };
        this.lookupLoaded = {
            stockType: false,
            delCompleteInd: false,
            sloc: false,
            mvtype: false,
            specialstock: false,
            valtype: false,
            vendor: false,
            reasonMv: false,
            plant: false,
            material: false,
            costCenter: false
        };
        this.errorListsGi = {
            postClicked: false,
            requiredAll: false,
            snNotSame: false,
            listItem: [],
            listHeader: []
        };
        this.giHeaderForm = {
            typeReceipt: 'Goods Issue',
            typeOrder: null,
            orderNumber: null,
            equipment: null,
            reservationNumber: null,
            noPurchaseOrder: null,
            poItem: null,
            itemNo: '',
            documentDate: moment(new Date()).format('DD MMM YYYY'),
            deliveryNote: null,
            supplier: null,
            postingDate: moment(new Date()).format('DD MMM YYYY'),
            billOfLading: null,
            headerText: null,
            giUploadAttachment: [],
            vendorName: null,
            vendorNumber: null,
            submitClick: false,
            uploadGi: [],
            movementType: null,
            specialStock: null,
            documentStatus: '',
            documentStatusCode: '',
            documentType: '',
            bSpaceMatDoc: '',
            materialDocument: '',
            hasMatDoc: null,
            materialSlip: '',
            isCancelDoc: false
        };
        this.giItemForm = {
            documentType: '',
            viewType: '',
            current: {},
            list: [],
            totalRecords: 0,
            totalPages: 0
        };
        this.headerErrorGi = {
            documentDate: false,
            materialSlip: false,
            postingDate: false,
            docHeaderText: false
        };
        this.selectedGiItem = {};
        this.giItemSelected = {
            current: {},
            list: [],
            selectedItem: [],
            isAllSelected: false
        };
        this.tempGiOther = [];
        this.nextPrevItems = {
            list: []
        };
    }
    get getIsOnImportGi() {
        return this.isOnImport;
    }
    get getViewHeaderGi() {
        return this.viewHeader;
    }
    get getNextPrevItemsGiMigo() {
        return this.nextPrevItems;
    }
    get getTempGiOther() {
        return this.tempGiOther;
    }
    get getErrorListGiOther() {
        return this.errorListGiOther;
    }
    get getErrorListGiCreate() {
        return this.errorListGiCreate;
    }
    get getImportFileGi() {
        return this.importFileGi;
    }
    get getLookupLoadedGi() {
        return this.lookupLoaded;
    }
    get getIsGiSearched() {
        return this.isGiSearched;
    }
    get getTabConditionGi() {
        return this.tabConditionGi;
    }
    get getErrorListsGi() {
        return this.errorListsGi;
    }
    get getGiHeaderForm() {
        return this.giHeaderForm;
    }
    get getGiLookup() {
        return this.giLookup;
    }
    get getHeaderErrorGi() {
        return this.headerErrorGi;
    }
    get getTempIdGi() {
        return this.tempId;
    }
    get getGiItemList() {
        return this.giItemForm;
    }
    get getHeaderIdGi() {
        return this.headerId;
    }
    get getGiSelectedItem() {
        return this.giItemSelected;
    }
    get getTypeOrderGi() {
        return this.giHeaderForm;
    }
    get getTypeOfDocument() {
        return this.typeOfDocument;
    }
    ['setPlantListGi'](data) {
        this.giItemForm.list[data.index].whereTab.plantCode = data.plantCodeValue;
        this.giItemForm.list[data.index].whereTab.plantName = data.plantNameValue;
    }
    ['setIsOnImportGi'](data) {
        this.isOnImport = data;
    }
    ['setNextPrevGiMigo'](data) {
        this.nextPrevItems.list = data;
    }
    ['setTempGiOther']({ value, tabParent, tabChild, line }) {
        const index = this.tempGiOther.findIndex((e) => {
            return e.line == line;
        });
        const obj = {
            val: value
        };
        this.tempGiOther[index][tabParent][tabChild] = obj.val;
    }
    ['resetTempGiOther']() {
        this.tempGiOther = [];
    }
    ['pushTempGiOther'](data) {
        this.tempGiOther.push(data);
    }
    ['setSelectedListItemGi'](data) {
        this.giItemSelected.selectedItem = data;
    }
    ['addGiOther']() {
        let isOrderDisabled = false;
        let isCostCenterDisabled = false;
        if (this.giHeaderForm.movementType == '201')
            isOrderDisabled = true;
        else
            isCostCenterDisabled = true;
        const obj = {
            materialTab: {
                material: null,
                materialDesc: null,
                supplierMatNo: null,
                materialGroup: null,
                valType: null,
                valCat: null,
                mpnMaterial: null,
                equipment: null
            },
            quantityTab: {
                baseUom: null,
                qtySKU: null,
                baseSku: null,
                quantityOrdered: null,
                uoMOrdered: null,
                qty: null,
                goodsReceiptQuantity: null
            },
            whereTab: {
                movementType: this.giHeaderForm.movementType,
                slocCode: null,
                specialStock: this.giHeaderForm.specialStock,
                type: null,
                plantCode: null,
                plantName: null,
                textItem: null,
                stockTypeCode: 'UnrestrictedUse',
                storageBin: null,
                unloadingPoint: null,
                goodsRecipient: null,
                vendorCode: null,
                vendorName: null
            },
            poDataTab: {
                purchaseOrder: null,
                purchaseOrderItem: null,
                requsitioner: null,
                delCompleteIndCode: null
            },
            partnerTab: {
                manufacturer: null,
                manufacturerNumber: null,
                plantNumber: null,
                supplyingPlant: null,
                supplyingPlantNumber: null,
                vendorCode: null,
                vendorName: null
            },
            accountAssignmentTab: {
                profitCenter: null,
                costCenter: null,
                glAccount: null,
                asset: null,
                assetSubNumber: null,
                functionalArea: null,
                wbsElement: null,
                orderNumber: null,
                orderDisabled: isOrderDisabled,
                costCenterDisabled: isCostCenterDisabled
            },
            serialNumberTab: {
                isSNIndicator: false,
                listSerialNumbers: null
            },
            enableFields: [
                'materialTab.materialDesc',
                'materialTab.valType',
                'quantityTab.qty',
                'whereTab.movementType',
                'whereTab.specialStock',
                'whereTab.slocCode',
                'whereTab.goodsRecipient',
                'whereTab.unloadingPoint',
                'whereTab.stockTypeCode',
                'whereTab.textItem',
                'whereTab.plantName',
                'partnerTab.vendorName',
                'accountAssignmentTab.costCenter',
                'accountAssignmentTab.orderNumber'
            ],
            popoitemgrid: null,
            subConts: null,
            hideFields: [
                'materialTab.supplierMatNo',
                'materialTab.mpnMaterial',
                'materialTab.equipment',
                'quantityTab.quantityOrdered',
                'quantityTab.uoMOrdered',
                'quantityTab.goodsReceiptQuantity',
                'poDataTab.requsitioner',
                'poDataTab.purchaseOrder',
                'poDataTab.purchaseOrderItem',
                'poDataTab.delCompleteIndCode',
                'whereTab.vendorName',
                'whereTab.vendorCode',
                'whereTab.reasonForMovement',
                'whereTab.reasonMovement',
                'partnerTab.supplyingPlant',
                'partnerTab.supplyingPlantNumber',
                'partnerTab.plantNumber',
                'partnerTab.manufacturer',
                'partnerTab.manufacturerNumber',
                'accountAssignmentTab.asset',
                'accountAssignmentTab.assetSubNumber',
                'accountAssignmentTab.functionalArea',
                'accountAssignmentTab.wbsElement',
                'accountAssignmentTab.businessArea',
                'accountAssignmentTab.profitCenter',
                'accountAssignmentTab.orderNumberItem',
                'accountAssignmentTab.profitCenter'
            ],
            mandatoryFields: [
                'materialTab.materialDesc',
                'quantityTab.qty',
                'whereTab.movementType',
                'whereTab.plantName',
                'whereTab.stockTypeCode',
                'whereTab.slocCode'
            ],
            line: this.giItemForm.list.length + 1,
            detailId: this.giItemForm.list.length + 1,
            materialDocumentItem: null,
            categoryItem: null,
            isSnNotBlank: false,
            totalRecords: null,
            createdBy: null,
            createdDate: null,
            modifiedby: null,
            modifiedDate: null,
            errors: [],
            onEdit: true,
            isActive: true,
            isSaved: false,
            isSaveClicked: false,
            grType: 1,
            hasChildren: false,
            isDisabledDelete: false
        };
        this.giItemForm.list.push(obj);
        this.giItemSelected.current = obj;
        const check = this.giItemSelected.list.findIndex((s) => {
            return s.detailId == obj.detailId;
        });
        if (check != -1)
            return;
        this.giItemSelected.list.push(obj);
    }
    ['addGiOtherFromImport'](data) {
        const inputOtherType = data.type
            ? data.type === 'change' || data.type === 'cancel'
                ? true
                : false
            : false;
        const checkMaterial = data.materialTab.material == '' || data.materialTab.material == null;
        let isOrderDisabled = false;
        let isCostCenterDisabled = false;
        if (data.whereTab.movementType == '202')
            isOrderDisabled = true;
        else
            isCostCenterDisabled = true;
        const obj = {
            materialTab: {
                material: data.materialTab.materialDesc,
                materialDesc: checkMaterial
                    ? null
                    : {
                        lookupVal: data.materialTab.material,
                        lookupText: data.materialTab.materialDesc,
                        lookupValText: data.materialTab.material +
                            ' | ' +
                            data.materialTab.materialDesc,
                        lookupData: null
                    },
                supplierMatNo: data.materialTab.supplierMatNo,
                materialGroup: data.materialTab.materialGroup,
                valType: data.materialTab.valType,
                valCat: data.materialTab.valCat,
                mpnMaterial: data.materialTab.mpnMaterial,
                equipment: data.materialTab.equipment
            },
            quantityTab: {
                baseUom: data.quantityTab.baseUom,
                qtySKU: data.quantityTab.qtySKU,
                baseSku: data.quantityTab.baseSku,
                quantityOrdered: data.quantityTab.quantityOrdered,
                uoMOrdered: data.quantityTab.uoMOrdered,
                qty: data.quantityTab.qty,
                goodsReceiptQuantity: data.quantityTab.goodsReceiptQuantity
            },
            whereTab: {
                movementType: data.whereTab.movementType,
                slocCode: data.whereTab.slocCode == null
                    ? null
                    : {
                        lookupVal: data.whereTab.slocCode,
                        lookupText: data.whereTab.slocName,
                        lookupValText: data.whereTab.slocCode + ' | ' + data.whereTab.slocName
                    },
                specialStock: data.whereTab.specialStock,
                type: data.whereTab.type,
                plantCode: data.whereTab.plantCode,
                plantName: {
                    lookupVal: data.whereTab.plantCode,
                    lookupText: data.whereTab.plantName,
                    lookupValText: data.whereTab.plantCode + ' | ' + data.whereTab.plantName,
                    lookupData: null
                },
                textItem: data.whereTab.textItem,
                stockTypeCode: data.whereTab.stockTypeCode,
                storageBin: data.whereTab.storageBin,
                unloadingPoint: data.whereTab.unloadingPoint,
                goodsRecipient: data.whereTab.goodsRecipient,
                vendorCode: inputOtherType ? data.whereTab.vendorCode : null,
                vendorName: inputOtherType ? data.whereTab.vendorName : null,
                reasonMovementName: data.whereTab.reasonMovementCode
                    ? {
                        lookupVal: data.whereTab.reasonMovementCode,
                        lookupText: data.whereTab.reasonMovementName,
                        lookupValText: data.whereTab.reasonMovementCode +
                            ' | ' +
                            data.whereTab.reasonMovementName,
                        lookupData: null
                    }
                    : null,
                reasonMovementDisplay: data.whereTab.reasonMovementDisplay,
                slocName: data.whereTab.slocName,
                stockTypeName: data.whereTab.stockTypeName
            },
            poDataTab: inputOtherType
                ? data.poDataTab
                : {
                    purchaseOrder: null,
                    purchaseOrderItem: null,
                    requsitioner: null,
                    delCompleteIndCode: null
                },
            partnerTab: inputOtherType
                ? data.partnerTab
                : {
                    manufacturer: null,
                    manufacturerNumber: null,
                    plantNumber: null,
                    supplyingPlant: null,
                    supplyingPlantNumber: null,
                    vendorCode: data.partnerTab.vendorCode,
                    vendorName: data.partnerTab.vendorName == null
                        ? null
                        : {
                            lookupVal: data.partnerTab.vendorCode,
                            lookupText: data.partnerTab.vendorName,
                            lookupValText: data.partnerTab.vendorCode +
                                ' | ' +
                                data.partnerTab.vendorName,
                            lookupData: null
                        }
                },
            accountAssignmentTab: inputOtherType
                ? data.accountAssignmentTab
                : {
                    profitCenter: data.accountAssignmentTab.profitCenter,
                    costCenter: data.accountAssignmentTab.costCenter,
                    glAccount: data.accountAssignmentTab.glAccount,
                    asset: data.accountAssignmentTab.asset,
                    assetSubNumber: data.accountAssignmentTab.assetSubNumber,
                    functionalArea: data.accountAssignmentTab.functionalArea,
                    wbsElement: data.accountAssignmentTab.wbsElement,
                    orderNumber: data.accountAssignmentTab.orderNumber,
                    orderDisabled: isOrderDisabled,
                    costCenterDisabled: isCostCenterDisabled
                },
            serialNumberTab: inputOtherType
                ? data.serialNumberTab
                : {
                    isSNIndicator: data.serialNumberTab.isSNIndicator,
                    listSerialNumbers: data.serialNumberTab.listSerialNumbers
                },
            enableFields: inputOtherType
                ? data.enableFields
                : [
                    'materialTab.materialDesc',
                    'materialTab.valType',
                    'quantityTab.qty',
                    'whereTab.movementType',
                    'whereTab.specialStock',
                    'whereTab.slocCode',
                    'whereTab.reasonMovement',
                    'whereTab.goodsRecipient',
                    'whereTab.unloadingPoint',
                    'whereTab.stockTypeCode',
                    'whereTab.textItem',
                    'whereTab.plantName',
                    'partnerTab.vendorName',
                    'accountAssignmentTab.costCenter',
                    'accountAssignmentTab.orderNumber'
                ],
            mandatoryFields: inputOtherType
                ? data.mandatoryFields
                : [
                    'materialTab.materialDesc',
                    'quantityTab.qty',
                    'whereTab.movementType',
                    'whereTab.slocCode',
                    'whereTab.reasonMovement',
                    'whereTab.stockTypeCode',
                    'whereTab.plantName'
                ],
            popoitemgrid: inputOtherType ? data.popoitemgrid : null,
            subConts: inputOtherType ? data.subConts : null,
            hideFields: inputOtherType
                ? data.hideFields
                : [
                    'materialTab.supplierMatNo',
                    'materialTab.mpnMaterial',
                    'materialTab.equipment',
                    'quantityTab.quantityOrdered',
                    'quantityTab.uoMOrdered',
                    'quantityTab.goodsReceiptQuantity',
                    'poDataTab.requsitioner',
                    'poDataTab.purchaseOrder',
                    'poDataTab.purchaseOrderItem',
                    'poDataTab.delCompleteIndCode',
                    'whereTab.vendorName',
                    'whereTab.vendorCode',
                    'partnerTab.supplyingPlant',
                    'partnerTab.supplyingPlantNumber',
                    'partnerTab.plantNumber',
                    'partnerTab.manufacturer',
                    'partnerTab.manufacturerNumber',
                    'accountAssignmentTab.asset',
                    'accountAssignmentTab.assetSubNumber',
                    'accountAssignmentTab.functionalArea',
                    'accountAssignmentTab.glAccount',
                    'accountAssignmentTab.wbsElement',
                    'accountAssignmentTab.businessArea',
                    'accountAssignmentTab.profitCenter'
                ],
            line: data.line,
            detailId: inputOtherType ? data.detailId : data.line,
            materialDocumentItem: data.materialDocumentItem,
            categoryItem: inputOtherType ? data.categoryItem : null,
            isSnNotBlank: data.isSnNotBlank,
            totalRecords: inputOtherType ? data.totalRecords : null,
            createdBy: inputOtherType ? data.createdBy : null,
            createdDate: inputOtherType ? data.createdDate : null,
            modifiedby: null,
            modifiedDate: null,
            errors: [],
            onEdit: false,
            isActive: inputOtherType ? false : true,
            isSaved: true,
            isSaveClicked: false,
            isDisabledDelete: false,
            isCanceled: data.isCanceled,
            isCancelDoc: data.isCancelDoc,
            disableCheckbox: data.type === 'cancel' ? data.isCanceled : false,
            hasChildren: data.hasChildren
        };
        const errorListObj = {
            materialDesc: false,
            qty: false,
            slocCode: false,
            stockTypeCode: false,
            vendorName: false,
            costCenter: false,
            orderNumber: false,
            movementType: false
        };
        this.errorListGiOther.push(errorListObj);
        this.giItemForm.list.push(obj);
        this.giItemSelected.current = obj;
        const check = this.giItemSelected.list.findIndex((s) => {
            return s.detailId == obj.detailId;
        });
        if (check != -1)
            return;
        this.giItemSelected.list.push(obj);
        this.giItemSelected.selectedItem.push(obj);
    }
    ['setIsSnNotBlankGi'](data) {
        const indexes = this.giItemForm.list.findIndex((e) => {
            return e.line === data.line;
        });
        if (indexes !== -1)
            this.giItemForm.list[indexes].isSnNotBlank = data.res;
    }
    ['setEditItemSelectedGi']({ index, data }) {
        this.giItemSelected.list[index] = data;
    }
    ['setSelectedListItemByIndexGi']({ index, data }) {
        this.giItemSelected.selectedItem[index] = data;
    }
    ['afterCountDownGi'](data) {
        data.forEach((g) => {
            if (g.field.tabCode.toLowerCase() != 'header') {
                const split = g.field.name.split('-');
                const index = this.giItemForm.list.findIndex((e) => {
                    return e.line == split[1];
                });
                this.errorListGiOther[index][split[2]] = true;
                this.giItemForm.list[index].onEdit = true;
                this.giItemForm.list[index].isActive = true;
                this.giItemForm.list[index].isDisabledDelete = true;
            }
        });
    }
    ['deleteErrorListGiOther']() {
        this.errorListGiOther = [];
    }
    ['setImportFileGiOther']({ files, data, isError }) {
        if (isError)
            this.importFileGi.isError = isError;
        else {
            this.importFileGi.store.push(data);
            this.importFileGi.files = files;
            this.importFileGi.isError = isError;
        }
    }
    ['deleteImportFileGiOtherr'](fileName) {
        const index = this.importFileGi.store
            .map((x) => {
            return x.originalFileName;
        })
            .indexOf(fileName);
        this.importFileGi.store.splice(index, 1);
        this.importFileGi.files = null;
        this.importFileGi.isError = false;
    }
    ['SetLookupLoadedGi'](data) {
        this.lookupLoaded[data.obj] = data.value;
    }
    ['setStorageBinGi'](data) {
        this.giItemSelected.current.whereTab.storageBin = data;
    }
    ['setIsGiSearched'](data) {
        this.isGiSearched = data;
    }
    ['setTabConditionGi'](data) {
        this.tabConditionGi = data;
    }
    ['setGiLookup']({ obj, data }) {
        this.giLookup[obj] = data;
    }
    ['setGiUpload'](data) {
        this.giHeaderForm.uploadGi.push(data);
    }
    ['setGiHeader'](data) {
        this.giHeaderForm.orderNumber = data.orderNumber;
        this.giHeaderForm.itemNo = data.poItem;
        this.giHeaderForm.equipment = data.equipment;
    }
    ['setTempId'](data) {
        this.tempId = data;
    }
    ['setGiItemList'](dataObj) {
        this.giItemForm.documentType = dataObj.data[0].typeOrder;
        this.giItemForm.viewType = dataObj.data[0].mode;
        this.giItemForm.list = dataObj.data;
        this.giItemForm.totalPages = dataObj.totalPages;
        this.giItemForm.totalRecords = dataObj.totalRecords;
    }
    ['setGiItemCurrent'](data) {
        this.giItemForm.current = data;
    }
    ['setPostClickedGi'](data) {
        this.errorListsGi.postClicked = data;
    }
    ['setHeaderIdGi'](data) {
        this.headerId = data;
    }
    ['setErrorRequiredAllGi'](data) {
        this.errorListsGi.requiredAll = data;
    }
    ['setErrorSnNotSameGi'](data) {
        this.errorListsGi.snNotSame = data;
    }
    ['setErrorListItemGi'](data) {
        this.errorListsGi.listItem = data;
        this.giItemSelected.list.forEach((g) => {
            g.errors = [...data];
        });
    }
    ['setErrorListHeaderGi'](data) {
        this.errorListsGi.listHeader = data;
    }
    ['setTypeOrderGi'](data) {
        this.giHeaderForm.typeOrder = data;
    }
    ['setClearSelectedItemGi']() {
        this.giItemSelected.selectedItem = [];
    }
    ['setListGiItem'](data) {
        this.giItemForm = data;
    }
    ['setDetailGiHeader'](data) {
        const header = data.header;
        this.giHeaderForm.noPurchaseOrder = header.poNumber;
        (this.giHeaderForm.typeOrder =
            header.typeOrder === 'Purchase Order'
                ? 'PurchaseOrder'
                : header.typeOrder),
            (this.giHeaderForm.documentDate = moment(header.documentDate).format('DD MMM YYYY'));
        this.giHeaderForm.postingDate = moment(header.postingDate).format('DD MMM YYYY');
        this.giHeaderForm.headerText = header.docHeaderText;
        this.giHeaderForm.movementType = header.movementType;
        this.giHeaderForm.specialStock = header.specialStock;
        this.giHeaderForm.documentStatus = header.documentStatus;
        this.giHeaderForm.documentStatusCode = header.documentStatusCode;
        this.giHeaderForm.documentType = header.documentType;
        this.giHeaderForm.bSpaceMatDoc = header.bSpaceMatDoc;
        this.giHeaderForm.materialDocument = header.materialDocument;
        this.giHeaderForm.materialSlip = header.materialSlip;
        this.giHeaderForm.uploadGi = data.attachments;
        (this.giHeaderForm.hasMatDoc = header.hasMatDoc),
            (this.giHeaderForm.isCancelDoc = header.isCancelDoc);
        this.giHeaderForm.orderNumber = header.orderNumber;
        this.giHeaderForm.reservationNumber = header.reservation;
        this.giHeaderForm.equipment = header.equipment;
    }
    ['setViewHeaderGi'](data) {
        this.viewHeader = data;
    }
    ['setResetViewHeaderGi']() {
        this.viewHeader = {};
    }
    ['resetGi']() {
        this.isGiSearched = false;
        this.tabConditionGi = 'header';
        this.tempId = null;
        this.giHeaderForm = {
            typeReceipt: 'Goods Issue',
            typeOrder: null,
            orderNumber: null,
            equipment: null,
            reservationNumber: null,
            noPurchaseOrder: null,
            poItem: null,
            itemNo: '',
            documentDate: moment(new Date()).format('DD MMM YYYY'),
            deliveryNote: null,
            supplier: null,
            postingDate: moment(new Date()).format('DD MMM YYYY'),
            billOfLading: null,
            headerText: null,
            giUploadAttachment: [],
            vendorName: null,
            vendorNumber: null,
            submitClick: false,
            uploadGi: [],
            movementType: null,
            specialStock: null,
            documentStatus: '',
            documentStatusCode: '',
            documentType: '',
            bSpaceMatDoc: '',
            materialDocument: '',
            hasMatDoc: null,
            materialSlip: '',
            isCancelDoc: false
        };
        this.nextPrevItems = {
            list: []
        };
        this.giItemForm = {
            documentType: '',
            viewType: '',
            current: {},
            list: [],
            totalRecords: 0,
            totalPages: 0
        };
        this.giItemSelected = {
            current: {},
            list: [],
            selectedItem: [],
            isAllSelected: false
        };
        this.headerErrorGi = {
            documentDate: false,
            materialSlip: false,
            postingDate: false,
            docHeaderText: false
        };
        this.errorListsGi = {
            postClicked: false,
            requiredAll: false,
            snNotSame: false,
            listItem: [],
            listHeader: []
        };
        this.importFileGi.files = null;
        this.importFileGi.store = [];
        this.importFileGi.isError = false;
        this.importFileGi.isImported = false;
        this.importFileGi.isAllowImport = true;
        this.errorListGiOther = [
            {
                materialDesc: false,
                qty: false,
                slocCode: false,
                stockTypeCode: false,
                vendorName: false,
                costCenter: false,
                orderNumber: false,
                movementType: false
            }
        ];
        this.lookupLoaded = {
            stockType: false,
            delCompleteInd: false,
            sloc: false,
            mvtype: false,
            specialstock: false,
            valtype: false,
            vendor: false,
            reasonMv: false,
            plant: false,
            material: false,
            costCenter: false
        };
    }
    ['setSelectedGiItem'](data) {
        this.giItemSelected.selectedItem = data;
    }
    ['setSelectedGiItemByIndex'](data) {
        this.giItemSelected.selectedItem.push(data);
    }
    ['setDeleteSelectedItemGi'](data) {
        this.giItemSelected.selectedItem.splice(data, 1);
    }
    ['setCurrentGiItemSelected'](data) {
        this.giItemSelected.current = data;
    }
    ['setListGiItemSelected'](data) {
        const check = this.giItemSelected.list.findIndex((s) => {
            return s.detailId == data.detailId;
        });
        if (check != -1)
            return (this.giItemSelected.list[check] = data);
        this.giItemSelected.list.push(data);
    }
    ['setCurrentItemSelectedGi'](data) {
        this.giItemSelected.current = data;
    }
    ['setTypeOfDocument'](data) {
        this.typeOfDocument = data;
    }
    ['callSearchGi']({ conditions, payload, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = conditions === 'header'
                ? `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/${type}/${conditions}?ver=v1`
                : `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/detail/${this.tempId}/stageitem?ver=v1`;
            const params = payload;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result;
                    const content = data.content;
                    this.context.commit('resetErrorListGiCreate');
                    if (data.isError) {
                        this.context.commit('setErrorHandlerMigo', data);
                        resolve();
                    }
                    else {
                        if (conditions === 'header') {
                            this.context.commit('setIsGiSearched', true);
                            this.context.commit('setGiHeader', content);
                            this.context.commit('setTempId', content.tempId);
                        }
                        else if (conditions === 'item') {
                            const errorList = {
                                materialDesc: false,
                                qty: false,
                                slocCode: false,
                                stockTypeCode: false,
                                vendorName: false,
                                costCenter: false,
                                orderNumber: false,
                                movementType: false
                            };
                            const dataList = {
                                data: [],
                                totalPages: content.totalPages,
                                totalRecords: content.totalRecords
                            };
                            content.data.forEach((g) => {
                                dataList.data.push(Object.assign({ checked: false, onEdit: false, isActive: false, isSaved: true }, g));
                                this.errorListGiCreate.push({
                                    line: g.line,
                                    materialDesc: false,
                                    qty: false,
                                    slocCode: false,
                                    stockTypeCode: false,
                                    vendorName: false,
                                    costCenter: false,
                                    orderNumber: false,
                                    movementType: false,
                                    reasonMovementName: false,
                                    textItem: false,
                                    reasonMovementCode: false
                                });
                            });
                            this.context.commit('setGiItemList', dataList);
                            this.context.commit('setListGiItemSelected', dataList.data);
                            this.context.commit('setGiItemCurrent', content.data[0]);
                            this.context.commit('setCurrentGiItemSelected', content.data[0]);
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['uploadFilesGiHeader']({ file, apiUrl }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${process.env.VUE_APP_BASE_URL_DIGITAL}` + apiUrl;
            // eslint-disable-next-line prefer-const, no-var
            let dataForm = new FormData();
            dataForm.append('request', file);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(url, dataForm)
                    .then((response) => {
                    const check = response.data.result;
                    if (check.isError) {
                        this.context.commit('setErrorHandlerMigo', check);
                        resolve();
                    }
                    else {
                        const data = check.content;
                        const fileName = `${data[0].originalFileName}.${data[0].fileType}`;
                        const getFile = this.giHeaderForm.uploadGi.findIndex((s) => {
                            return s.originalFileName == fileName;
                        });
                        if (getFile >= 0) {
                            this.giHeaderForm.uploadGi[getFile] = Object.assign(Object.assign({}, data[0]), { isSuccessDownload: false, isFailedDownload: false, isDownloading: false });
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['deleteFileGiHeader'](fileUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/upload?ver=v1&fileUrl=` +
                fileUrl;
            return yield new Promise((resolve, reject) => {
                ApiService.delete(apiUrl)
                    .then(() => {
                    const index = this.giHeaderForm.uploadGi
                        .map((x) => {
                        return x.formattedFileName;
                    })
                        .indexOf(fileUrl);
                    this.giHeaderForm.uploadGi.splice(index, 1);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callDetailHeaderGi'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/detail/${headerId}?ver=v1&viewType=` +
                data.type;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        this.context.commit('setDetailGiHeader', Object.assign(Object.assign({}, res.content), { type: data.type }));
                        this.context.commit('setViewHeaderGi', res.content);
                        const headerData = res.content.header;
                        const errorItem = [];
                        if (!headerData.isSAPSuccess) {
                            const getList = headerData.sapMessage.split(',');
                            getList.forEach((item) => {
                                const getLineName = item.split(':');
                                if (getLineName.length === 1) {
                                    errorItem.push({
                                        field: {
                                            name: '',
                                            tabCode: ''
                                        },
                                        errors: []
                                    });
                                    errorItem[0].errors.push(getLineName[0]);
                                    return;
                                }
                                const getNumberLine = getLineName[0].split(' ');
                                const checkError = errorItem.findIndex((itemSub) => {
                                    const getLine = itemSub.field.name.split('-');
                                    return getLine[1] === getNumberLine[1];
                                });
                                if (checkError !== -1) {
                                    errorItem[checkError].errors.push(getLineName[1]);
                                }
                                else {
                                    const messageData = () => {
                                        let message = '';
                                        getLineName.forEach((e, index) => {
                                            if (index !== 0)
                                                message += e + ' ';
                                        });
                                        return message;
                                    };
                                    errorItem.push({
                                        field: {
                                            name: `Item-${getNumberLine[1]}`,
                                            tabCode: ''
                                        },
                                        errors: [
                                            getList.length === 1
                                                ? headerData.sapMessage
                                                : messageData()
                                        ]
                                    });
                                }
                            });
                            this.context.commit('setErrorListItemGi', errorItem);
                        }
                        resolve(res.content);
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    ['callDetailItemGi'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const type = data.params.viewType;
            const payloadData = data.params;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/detail/${headerId}/item?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, payloadData)
                    .then((response) => {
                    this.context.commit('setClearSelectedItemGi');
                    const res = response.data.result;
                    this.context.commit('resetErrorListGiCreate');
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        if (type === 'change') {
                            this.giItemForm.list = [];
                            this.giItemSelected.list = [];
                            this.context.commit('deleteErrorListGiOther');
                            if (this.giHeaderForm.typeOrder === 'Other') {
                                const data = res.content.data;
                                store.commit('resetTempGiOther');
                                data.forEach((e) => {
                                    store.commit('addGiOtherFromImport', Object.assign(Object.assign({}, e), { type }));
                                    const obj = {
                                        line: e.line,
                                        materialTab: {
                                            material: null,
                                            materialDesc: null,
                                            valType: null
                                        },
                                        quantityTab: {
                                            baseUom: null,
                                            qty: null
                                        },
                                        whereTab: {
                                            movementType: null,
                                            slocCode: null,
                                            specialStock: null,
                                            plantCode: null,
                                            plantName: null,
                                            textItem: null,
                                            stockTypeCode: null,
                                            storageBin: null,
                                            unloadingPoint: null,
                                            goodsRecipient: null
                                        },
                                        partnerTab: {
                                            vendorCode: null,
                                            vendorName: null
                                        },
                                        accountAssignmentTab: {
                                            costCenter: null,
                                            orderNumber: null
                                        }
                                    };
                                    store.commit('pushTempGiOther', obj);
                                });
                            }
                            else {
                                store.commit('resetTempGiOther');
                                this.giItemForm.list = res.content.data;
                                this.giItemSelected.list = this.giItemForm.list;
                                this.giItemSelected.selectedItem = this.giItemForm.list;
                            }
                            this.giItemForm.totalPages = res.content.totalPages;
                            this.giItemForm.totalRecords = res.content.totalRecords;
                            this.context.commit('setListGiItem', Object.assign(Object.assign({}, this.giItemForm), { totalPages: res.content.totalPages, totalRecords: res.content.totalRecords }));
                            this.context.commit('setCurrentItemSelectedGi', this.giItemForm.list[0]);
                            if (type == 'change') {
                                this.giItemForm.list.forEach((e) => {
                                    e.isActive = true;
                                });
                            }
                            if (this.giHeaderForm.typeOrder !== 'Other') {
                                this.giItemForm.list.forEach((e) => {
                                    this.errorListGiCreate.push({
                                        line: e.line,
                                        materialDesc: false,
                                        qty: false,
                                        slocCode: false,
                                        stockTypeCode: false,
                                        vendorName: false,
                                        costCenter: false,
                                        orderNumber: false,
                                        movementType: false,
                                        reasonMovementName: false,
                                        textItem: false,
                                        reasonMovementCode: false
                                    });
                                });
                            }
                        }
                        else if (type === 'cancel') {
                            this.giItemForm.list = [];
                            this.giItemSelected.list = [];
                            this.context.commit('deleteErrorListGiOther');
                            if (this.giHeaderForm.typeOrder === 'Other') {
                                const data = res.content.data;
                                store.commit('resetTempGiOther');
                                data.forEach((e) => {
                                    store.commit('addGiOtherFromImport', Object.assign(Object.assign({}, e), { type }));
                                    const obj = {
                                        line: e.line,
                                        materialTab: {
                                            material: null,
                                            materialDesc: null,
                                            valType: null
                                        },
                                        quantityTab: {
                                            baseUom: null,
                                            qty: null
                                        },
                                        whereTab: {
                                            movementType: null,
                                            slocCode: null,
                                            specialStock: null,
                                            plantCode: null,
                                            plantName: null,
                                            textItem: null,
                                            stockTypeCode: null,
                                            storageBin: null,
                                            unloadingPoint: null,
                                            goodsRecipient: null
                                        },
                                        partnerTab: {
                                            vendorCode: null,
                                            vendorName: null
                                        },
                                        accountAssignmentTab: {
                                            costCenter: null,
                                            orderNumber: null
                                        }
                                    };
                                    store.commit('pushTempGiOther', obj);
                                    this.errorListGiCreate.push({
                                        line: e.line,
                                        materialDesc: false,
                                        qty: false,
                                        slocCode: false,
                                        stockTypeCode: false,
                                        vendorName: false,
                                        costCenter: false,
                                        orderNumber: false,
                                        movementType: false,
                                        reasonMovementName: false,
                                        textItem: false,
                                        reasonMovementCode: false
                                    });
                                });
                            }
                            else {
                                res.content.data.forEach((g) => {
                                    this.giItemForm.list.push(Object.assign({ checked: false, onEdit: false, isActive: g.isCanceled === true ? false : true, isSaved: true, disableCheckbox: g.isCanceled }, g));
                                    this.errorListGiCreate.push({
                                        line: g.line,
                                        materialDesc: false,
                                        qty: false,
                                        slocCode: false,
                                        stockTypeCode: false,
                                        vendorName: false,
                                        costCenter: false,
                                        orderNumber: false,
                                        movementType: false,
                                        reasonMovementName: false,
                                        textItem: false,
                                        reasonMovementCode: false
                                    });
                                });
                                this.giItemSelected.list = this.giItemForm.list;
                                const selectedItem = [];
                                this.giItemForm.list.forEach((g) => {
                                    if (g.isCanceled !== true)
                                        selectedItem.push(g);
                                });
                                this.giItemSelected.selectedItem = selectedItem;
                            }
                            this.giItemForm.totalPages = res.content.totalPages;
                            this.giItemForm.totalRecords = res.content.totalRecords;
                            this.context.commit('setListGiItem', Object.assign(Object.assign({}, this.giItemForm), { totalPages: res.content.totalPages, totalRecords: res.content.totalRecords }));
                            this.context.commit('setCurrentItemSelectedGi', this.giItemForm.list[0]);
                            if (type == 'change') {
                                this.giItemForm.list.forEach((e) => {
                                    e.isActive = true;
                                });
                            }
                            if (type == 'cancel') {
                                this.giItemForm.list.forEach((e) => {
                                    e.isActive = e.isCanceled ? false : true;
                                });
                            }
                        }
                        else {
                            this.context.commit('setTypeOfDocument', this.giHeaderForm.typeOrder);
                            this.context.commit('setGiItemList', res.content);
                            this.context.commit('setCurrentItemSelectedGi', res.content.data[0]);
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    ['submitPostGi']({ conditions, data, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/` +
                type +
                '/' +
                conditions +
                '?ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, data)
                    .then((response) => {
                    const res = response.data.result;
                    this.importFileGi.isError = false;
                    if (res.isError && res.content === null) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else if (res.isError && res.content != null) {
                        this.context.commit('setHeaderIdGi', res.content.headerId);
                        const errorItem = [];
                        const errorHeader = [];
                        if (res.content.isErrorSap) {
                            const fixValue = 'Order';
                            const obj = {
                                text: 'The display will switch to the "change" mode and please correct the data errors',
                                flag: conditions,
                                isErrorSap: true,
                                typeOrder: fixValue,
                                headerId: res.content.headerId
                            };
                            this.context.commit('setPreventDiscardMigo', true);
                            this.context.commit('setInformationMigo', obj);
                            resolve();
                        }
                        else {
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItemGi', errorItem);
                            this.context.commit('setErrorListHeaderGi', errorHeader);
                            this.giItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        const obj = {
                            text: res.message,
                            flag: conditions,
                            isErrorSap: false,
                            typeOrder: null,
                            headerId: null
                        };
                        if (res.content.isInProgressSAP)
                            this.context.commit('setInformationMigo', obj);
                        else
                            this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    ['cancelPostGi']({ conditions, data, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/cancel?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, data)
                    .then((response) => {
                    const res = response.data.result;
                    this.importFileGi.isError = false;
                    // this.headerId = 0
                    if (res.isError && res.content === null) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else if (res.isError && res.content != null) {
                        this.context.commit('setHeaderIdGi', res.content.headerId);
                        const errorItem = [];
                        const errorHeader = [];
                        if (res.content.isErrorSap) {
                            const fixValue = 'Order';
                            const obj = {
                                text: 'The display will switch to the "change" mode and please correct the data errors',
                                flag: conditions,
                                isErrorSap: true,
                                typeOrder: fixValue,
                                headerId: res.content.headerId
                            };
                            this.context.commit('setPreventDiscardMigo', true);
                            this.context.commit('setInformationMigo', obj);
                            resolve();
                        }
                        else {
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItemGi', errorItem);
                            this.context.commit('setErrorListHeaderGi', errorHeader);
                            this.giItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        const obj = {
                            text: res.message,
                            flag: conditions,
                            isErrorSap: false,
                            typeOrder: null,
                            headerId: null
                        };
                        if (res.content.isInProgressSAP)
                            this.context.commit('setInformationMigo', obj);
                        else
                            this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['callGetStorageBinGi'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = isObject(data.material)
                ? data.material.lookupVal
                : data.material;
            const plant = isObject(data.plant) ? data.plant.lookupVal : data.plant;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/storagebin?ver=v1&materialNumber=${material}&plant=${plant}&sloc=${data.sloc}`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((res) => {
                    this.context.commit('setStorageBinGi', res.data.result.content.storageBin);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callTypeOtherGi']({ mvtype, specialstock, theIndex }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/mvtype/desc?MovementType=` +
                mvtype +
                '&SpecialStock=' +
                specialstock +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        const content = axiosResponse.content;
                        this.giItemForm.list[theIndex].whereTab.type = content.mvtTypeDesc;
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['MigoImportFileGi']() {
        return __awaiter(this, void 0, void 0, function* () {
            this.importFileGi.isOnAsync = true;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/other/importexcel?ver=v1`;
            const dataForm = new FormData();
            dataForm.append('request', this.importFileGi.files);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    this.importFileGi.isOnAsync = false;
                    this.context.commit('setIsOnImportGi', true);
                    const res = response.data.result;
                    if (res.isError) {
                        if (res.content.data.length == 0) {
                            const errorData = {
                                statusCode: undefined,
                                message: res.content.errorSets[0].errors[0]
                            };
                            this.importFileGi.isError = true;
                            this.context.commit('setErrorHandlerMigo', errorData);
                            resolve();
                        }
                        else if (res.content.data.length > 0) {
                            this.importFileGi.isError = true;
                            this.importFileGi.isImported = true;
                            this.importFileGi.isAllowImport = false;
                            this.giItemForm.list = [];
                            this.giItemSelected.list = [];
                            this.context.commit('deleteErrorListGiOther');
                            const data = res.content.data;
                            let countDown = 0;
                            data.forEach((e) => {
                                countDown++;
                                store.commit('addGiOtherFromImport', e);
                                if (countDown === data.length) {
                                    store.commit('afterCountDownGi', res.content.errorSets);
                                }
                            });
                            const errorItem = [];
                            const errorHeader = [];
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItemGi', errorItem);
                            this.context.commit('setErrorListHeaderGi', errorHeader);
                            this.giItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        this.giItemForm.list = [];
                        this.giItemSelected.list = [];
                        this.context.commit('deleteErrorListGiOther');
                        this.importFileGi.isImported = true;
                        this.importFileGi.isAllowImport = false;
                        const data = res.content.data;
                        data.forEach((e) => {
                            store.commit('addGiOtherFromImport', e);
                        });
                        // Ganti modal gi
                        hideModal(document.getElementById('modal_import_gr_item'));
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callGetSnNotBlankGi'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = isObject(data.materialNumber)
                ? data.materialNumber.lookupVal
                : data.materialNumber;
            const plant = isObject(data.plantName)
                ? data.plantName.lookupVal
                : data.plantName;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/isnotblank?ver=v1&materialNumber=${material}&plant=${plant}`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((res) => {
                    const obj = {
                        res: res.data.result.content.isNotBlank,
                        line: data.line
                    };
                    this.context.commit('setIsSnNotBlankGi', obj);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callStorageBinGi']({ material, plant, sloc, index }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/storagebin?ver=v1&materialNumber=` +
                material +
                '&plant=' +
                plant +
                '&sloc=' +
                sloc;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        const content = axiosResponse.content;
                        this.giItemForm.list[index].whereTab.storageBin = content.storageBin;
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['migoImportTemplateGi']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/other/downloadtemplate?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.getBlob(apiUrl)
                    .then((response) => {
                    const fileName = response.headers['content-disposition']
                        .split('; ')[1]
                        .split('=')[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    this.context.commit('setPreventDiscardMigo', false);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['deleteGiTransactionList'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/goodsissue/delete/${headerId}?ver=v1`;
            const params = {};
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        const obj = {
                            id: data.id === 'modal_confirmation_gi' ? 'modal_success_gi' : null,
                            text: res.message
                        };
                        this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['updateErrorListGiCreate'](obj) {
        this.errorListGiCreate[obj.index][obj.property] = obj.value;
    }
    ['resetErrorListGiCreate'](obj) {
        this.errorListGiCreate = [];
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setPlantListGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setIsOnImportGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setNextPrevGiMigo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setTempGiOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'resetTempGiOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'pushTempGiOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setSelectedListItemGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'addGiOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'addGiOtherFromImport', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setIsSnNotBlankGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setEditItemSelectedGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setSelectedListItemByIndexGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'afterCountDownGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'deleteErrorListGiOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setImportFileGiOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'deleteImportFileGiOtherr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'SetLookupLoadedGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setStorageBinGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setIsGiSearched', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setTabConditionGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setGiLookup', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setGiUpload', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setGiHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setTempId', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setGiItemList', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setGiItemCurrent', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setPostClickedGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setHeaderIdGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setErrorRequiredAllGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setErrorSnNotSameGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setErrorListItemGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setErrorListHeaderGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setTypeOrderGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setClearSelectedItemGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setListGiItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setDetailGiHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setViewHeaderGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setResetViewHeaderGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'resetGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setSelectedGiItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setSelectedGiItemByIndex', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setDeleteSelectedItemGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setCurrentGiItemSelected', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setListGiItemSelected', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setCurrentItemSelectedGi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'setTypeOfDocument', null);
__decorate([
    Action({ rawError: true }),
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callSearchGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'uploadFilesGiHeader', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'deleteFileGiHeader', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callDetailHeaderGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callDetailItemGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'submitPostGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'cancelPostGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callGetStorageBinGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callTypeOtherGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'MigoImportFileGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callGetSnNotBlankGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'callStorageBinGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'migoImportTemplateGi', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionGiModule.prototype, 'deleteGiTransactionList', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'updateErrorListGiCreate', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionGiModule.prototype, 'resetErrorListGiCreate', null);
transactionGiModule = __decorate([
    Module
], transactionGiModule);
export default transactionGiModule;
